import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Brand from "../../../Components/layout/Brand";
import Navigation, {
  NavigationLine,
} from "../../../Components/layout/Navigation/Navigation";
import ThemeContext from "../../../Contexts/themeContext";
import User from "../../../Modules/User/User";
import { getSideMenuData } from "../../../Services/SideMenuService";
import AsideLayout, { AsideBody, AsideFoot, AsideHead } from "./AsideLayout";
import { useState } from "react";

const Aside = () => {
  const dispatch = useDispatch();
  const { asideStatus, setAsideStatus } = useContext(ThemeContext);
  const user = JSON.parse(localStorage.getItem("user"));
  const { sideMenuData } = useSelector((state) => state.sideMenu);
  const [updatedMenu, setUpdatedMenu] = useState([]);


  useEffect(() => {
    // if (sideMenuData?.length == 0) {
    dispatch(getSideMenuData(user?.role_id));

    // }
  }, [dispatch, user?.role_id]);
  useEffect(() => {
    if (!sideMenuData?.length) return;
    setUpdatedMenu(sideMenuData);
  }, [sideMenuData]);

  return (
    <AsideLayout>
      <AsideHead>
        <Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
      </AsideHead>

      <AsideBody>
        {updatedMenu?.length > 0 &&
          updatedMenu.map((menu, index) => (
            <React.Fragment key={Object.keys(menu)[0]}>
              <Navigation menu={menu} id={`aside-${Object.keys(menu)[0]}`} />
              {index !== updatedMenu.length - 1 && <NavigationLine />}
            </React.Fragment>
          ))}
      </AsideBody>

      <AsideFoot>
        <User />
      </AsideFoot>
    </AsideLayout>
  );
};

export default Aside;